import { Box, Typography } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';

import { Button, FormGrid } from 'components';

import { useQuoteCardStyles } from './QuoteCard.styles';

export const QuoteLine = ({
  title,
  value,
  editIcon,
  isEditDisabled,
  justifyTitle = 'space-between',
  justifyValue = 'space-between',
  alignItems = 'center',
  handleEdit,
}) => {
  const classes = useQuoteCardStyles();

  return (
    <>
      <FormGrid item xs={5}>
        <Box display="flex" justifyContent={justifyTitle} alignItems={alignItems} height="100%">
          <Typography variant="body2" className={classes.title}>
            {title}
          </Typography>
        </Box>
      </FormGrid>
      <FormGrid item xs={7}>
        <Box display="flex" justifyContent={justifyValue} alignItems={alignItems}>
          <Typography variant="body2" className={classes.value}>
            {value}
          </Typography>
          {editIcon && (
            <Button
              data-testid="edit-quote-button"
              size="xsmall"
              icon={EditIcon}
              variant="text"
              nestedClasses={{ icon: classes.icon }}
              onClick={handleEdit}
              disabled={isEditDisabled}
            />
          )}
        </Box>
      </FormGrid>
    </>
  );
};
